/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(5);
	
	// 通过全局变量获取分页信息
	var pageMeta = window.pageMeta;
	
	$('#pager').pager({
	    menu: {
	        pageSize: true
	    },
	    page: getQueryString('page') || 1,
	    total: pageMeta.total,
	    limit: getQueryString('limit') || 5,
	    onPaging: function onPaging(page, limit) {
	        window.location.search = '?page=' + page + '&limit=' + limit;
	    }
	});
	
	// 获取 url 参数
	function getQueryString(name) {
	    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	    var r = window.location.search.substr(1).match(reg);
	    if (r !== null) return window.decodeURI(r[2]);
	    return null;
	}

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = Pager;
	/**
	 * @requires jQuery
	 * @author Ei
	 */
	
	/**
	 * README
	 * 初始化 $(selector).pager({page:1,total:55}) Pager(selector,{page:1,total:55});
	 * page:当前页数
	 * limit:每页显示的条数
	 * total:总条数
	 * totalPages: 总页数
	 * range:显示页码范围，最好为奇数，如：1...2 3 4 5 6...10
	 * fix: 超过多少页数仍然不显示...
	 * type:[simple(只有翻页按钮),normal（翻页按钮，页码，首末）,complete（翻页按钮，页码，首末，详情，页数选择）]
	 * menu:{
	        pageTurn:true,//显示上下页
	        pageNumber:true,//显示页码
	        pageShortcut:true,//显示首末页
	        pageCount:true,//显示跳转
	        pageSize:false,//显示每页条数
	        pageInfo:false//显示详情
	    }
	 * pageSizeData:{ 自定义每页显示条数
	       options:[{value:5,text:'5条/页'},{value:10,text:'10条/页'}]
	  }
	 * beforePager(page,limit,total,totalPages) 跳转前执行(同步) return true继续执行 return false 中断
	 * onPaging(page,limit,total,totalPages) 跳转中执行(数据已经变更还未渲染 同步) return true继续执行 return false 中断
	 * afterPager(page,limit,total,totalPages) 跳转后执行(同步)
	 **/
	
	var DEFAULT = {
	    //[simple(只有翻页按钮),normal（翻页按钮，页码，首末）,complete（翻页按钮，页码，首末，详情，页数选择）]
	    type: 'normal',
	    menu: {
	        pageTurn: true, //显示上下页
	        pageNumber: true, //显示页码
	        pageShortcut: true, //显示首末页
	        pageCount: true, //显示跳转
	        pageSize: false, //显示每页条数
	        pageInfo: false //显示详情
	    },
	    range: 3,
	    fix: 3,
	    page: 1,
	    limit: 5,
	    total: 0,
	    pageSizeData: {},
	    beforePager: function beforePager() {
	        return true;
	    },
	    afterPager: function afterPager() {
	        return true;
	    },
	    onPaging: function onPaging() {
	        return true;
	    }
	};
	
	var SIMPLE_MENU = {
	    pageTurn: true,
	    pageNumber: false,
	    pageShortcut: false,
	    pageSize: false,
	    pageInfo: false,
	    pageCount: false
	};
	var COMPLETE_MENU = {
	    pageTurn: true,
	    pageNumber: true,
	    pageShortcut: true,
	    pageSize: true,
	    pageInfo: true,
	    pageCount: true
	};
	
	var TPL = {
	    pageTurn: '<a class="pager-btn pager-prev"><%=prev%></a><!--><a class="pager-btn pager-next"><%=next%></a>',
	    pageShortcut: '<a class="pager-btn pager-first"><%=first%></a><!--><a class="pager-btn pager-last"><%=last%></a>',
	    pageNumber: '<ul class="pager-number"></ul>',
	    pageBtn: '<li><a class="<%=className%>" data-page="<%=text%>"><%=text%></a></li>',
	    pageSize: '<select class="pager-size"><% for(var i=0;i < options.length; i++){ %><option value="<%=options[i].value%>"><%=options[i].text%></option><%}%></select>',
	    pageCount: '<input class="pager-count" value="<%=page%>"><button class="pager-count-btn"><%=text%></button>',
	    pageInfo: '<%=page%>/<%=totalPages%> 共<%=total%>条数据'
	};
	
	var LANG = {
	    pageTurn: {
	        prev: '上一页',
	        next: '下一页'
	    },
	    pageShortcut: {
	        first: '首页',
	        last: '末页'
	    },
	    pageSize: {
	        options: [{ value: 5, text: '5条/页' }, { value: 10, text: '10条/页' }]
	    },
	    pageCount: {
	        text: '跳转'
	    }
	};
	
	function Pager(elmSelector) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var $container = $(elmSelector);
	    var _options = options,
	        _options$type = _options.type,
	        type = _options$type === undefined ? DEFAULT.type : _options$type;
	
	    var $ul = void 0,
	        $pageInfo = void 0,
	        $pageCount = void 0,
	        $pageSize = void 0;
	    var setting = type === 'simple' ? {
	        menu: SIMPLE_MENU
	    } : type === 'complete' ? {
	        menu: COMPLETE_MENU
	    } : {};
	    options = $.extend(true, { totalPages: Math.ceil(options.total / options.limit || 1) }, DEFAULT, setting, options);
	    options.page = +options.page;
	
	    function init() {
	        $container.addClass('pager');
	        building();
	    }
	    function building() {
	        var tempTpl = tpl(TPL.pageTurn, LANG.pageTurn);
	        var _options2 = options,
	            page = _options2.page,
	            totalPages = _options2.totalPages,
	            pageSizeData = _options2.pageSizeData,
	            total = _options2.total;
	
	        var onPageTurnClick = paging('pageTurn');
	        $container.on('click.pager.pageTurn', '.pager-prev', function () {
	            onPageTurnClick([-1]);
	        }).on('click.pager.pageTurn', '.pager-next', function () {
	            onPageTurnClick([1]);
	        });
	
	        switchPipe('pageShortcut', function () {
	            var pageShortcutTpl = tpl(TPL.pageShortcut, LANG.pageShortcut);
	            var pageShortcutTplArr = pageShortcutTpl.split('<!-->');
	            var onPageShortcutClick = paging('pageShortcut');
	            tempTpl = '' + pageShortcutTplArr[0] + tempTpl + pageShortcutTplArr[1];
	            $container.on('click.pager.pageShortcut', '.pager-first', function () {
	                onPageShortcutClick([1]);
	            }).on('click.pager.pageShortcut', '.pager-last', function () {
	                onPageShortcutClick([totalPages]);
	            });
	        });
	
	        switchPipe('pageNumber', function () {
	            tempTpl = tempTpl.replace('<!-->', TPL.pageNumber);
	        });
	
	        switchPipe('pageSize', function () {
	            var onPageSizeChange = paging('pageSize');
	            tempTpl += tpl(TPL.pageSize, $.extend(true, {}, LANG.pageSize, pageSizeData));
	            $container.on('change.pager.pageSize', '.pager-size', function (e) {
	                onPageSizeChange([$(e.target).val()]);
	            });
	        });
	        switchPipe('pageCount', function () {
	            tempTpl += tpl(TPL.pageCount, $.extend(true, {}, LANG.pageCount, { page: page }));
	            var onPageCountChange = paging('pageCount');
	            $container.on('keypress.pager.pageCount', '.pager-count', function (e) {
	                if (e.keyCode == "13") {
	                    onPageCountChange([$(e.target)]);
	                }
	            }).on('focus.pager.pageCount', '.pager-count', function (e) {
	                $(e.target).select();
	            }).on('click.pager.pageCount', '.pager-count-btn', function () {
	                onPageCountChange([$pageCount]);
	            });
	        });
	
	        switchPipe('pageInfo', function () {
	            tempTpl += '<span class="pager-info">' + tpl(TPL.pageInfo, { page: page, totalPages: totalPages, total: total }) + '</span>';
	        });
	
	        tempTpl = tempTpl.replace(/<!-->/g, '');
	        $container.append(tempTpl);
	        $container = $(elmSelector);
	        $ul = $container.find('.pager-number');
	        $pageInfo = $container.find('.pager-info');
	        $pageCount = $container.find('.pager-count');
	        $pageSize = $container.find('.pager-size');
	        reSet();
	    }
	
	    function paging(type) {
	        var process = void 0;
	        switch (type) {
	            case 'pageCount':
	                {
	                    process = function process(el) {
	                        var val = el.val();
	                        if (!isNaN(val) && val != options.page) {
	                            val = val > 0 ? val <= options.totalPages ? val : options.totalPages : 1;
	                            el.val(options.page);
	                            options.page = +val;
	                            return true;
	                        } else {
	                            el.val(options.page);
	                            return false;
	                        }
	                    };
	                    break;
	                }
	            case 'pageShortcut':
	                {
	                    process = function process(val) {
	                        if (+val != options.page) {
	                            options.page = +val;
	                            return true;
	                        } else {
	                            return false;
	                        }
	                    };
	                    break;
	                }
	            case 'pageTurn':
	                {
	                    process = function process(val) {
	                        val = +val + options.page;
	                        if (val >= 1 && val <= options.totalPages) {
	                            options.page = val;
	                            return true;
	                        } else {
	                            return false;
	                        }
	                    };
	                    break;
	                }
	            case 'pageNumber':
	                {
	                    process = function process(val) {
	                        options.page = val;
	                        return true;
	                    };
	                    break;
	                }
	            case 'pageSize':
	                {
	                    process = function process(val) {
	                        options.limit = val;
	                        options.page = 1;
	                        options.totalPages = Math.ceil(options.total / options.limit || 1);
	                        return true;
	                    };
	                    break;
	                }
	        }
	        return function (params) {
	            var _options3 = options,
	                beforePager = _options3.beforePager,
	                afterPager = _options3.afterPager,
	                onPaging = _options3.onPaging;
	            //typeof beforePager === 'function' &&
	
	            beforePager(options.page, options.limit, options.total, options.totalPages) && process.apply(undefined, params) &&
	            //typeof onPaging === 'function' &&
	            onPaging(options.page, options.limit, options.total, options.totalPages) && reSet() &&
	            //typeof afterPager === 'function' &&
	            afterPager(options.page, options.limit, options.total, options.totalPages); //jshint ignore:line
	        };
	    }
	
	    function reSet() {
	        var _options4 = options,
	            page = _options4.page,
	            totalPages = _options4.totalPages,
	            total = _options4.total;
	        //设置首末、上下页的状态
	
	        $container.find('.pager-first,.pager-prev')[page <= 1 ? 'addClass' : 'removeClass']('disabled');
	        $container.find('.pager-last,.pager-next')[page >= totalPages ? 'addClass' : 'removeClass']('disabled');
	        switchPipe('pageNumber', function () {
	            buildPageNumberModule();
	        });
	        switchPipe('pageInfo', function () {
	            var tempTpl = tpl(TPL.pageInfo, { page: page, totalPages: totalPages, total: total });
	            $pageInfo && $pageInfo.html(tempTpl); //jshint ignore:line
	        });
	        switchPipe('pageCount', function () {
	            $pageCount.val(page);
	        });
	        switchPipe('pageSize', function () {
	            $pageSize.val(options.limit);
	        });
	        return true;
	    }
	    function switchPipe(type, doing) {
	        if (options.menu[type]) {
	            if (typeof doing === 'function') {
	                return doing();
	            }
	        }
	    }
	
	    function buildPageNumberModule() {
	        if (!$ul.length) {
	            return;
	        }
	        var _options5 = options,
	            page = _options5.page,
	            totalPages = _options5.totalPages,
	            range = _options5.range,
	            fix = _options5.fix,
	            tempTpl = '';
	
	        $ul.children().remove();
	
	        if (totalPages > range + fix) {
	            if (page < range) {
	                for (var i = 1; i <= range; i++) {
	                    tempTpl += tpl(TPL.pageBtn, { className: i === page ? 'pager-btn-current' : 'pager-btn', text: i });
	                }
	                tempTpl += tpl(TPL.pageBtn, { className: 'pager-dotted', text: '...' });
	                tempTpl += tpl(TPL.pageBtn, { className: 'pager-btn', text: totalPages });
	            } else {
	                tempTpl += tpl(TPL.pageBtn, { className: 'pager-btn', text: 1 });
	                if (totalPages - page < range - 1) {
	                    tempTpl += tpl(TPL.pageBtn, { className: 'pager-dotted', text: '...' });
	                    for (var _i = totalPages - range + 1; _i <= totalPages; _i++) {
	                        tempTpl += tpl(TPL.pageBtn, { className: _i === page ? 'pager-btn-current' : 'pager-btn', text: _i });
	                    }
	                } else {
	                    tempTpl += tpl(TPL.pageBtn, { className: 'pager-dotted', text: '...' });
	                    for (var _i2 = page - Math.floor(range / 2); _i2 < page + Math.ceil(range / 2); _i2++) {
	                        tempTpl += tpl(TPL.pageBtn, { className: _i2 === page ? 'pager-btn-current' : 'pager-btn', text: _i2 });
	                    }
	                    tempTpl += tpl(TPL.pageBtn, { className: 'pager-dotted', text: '...' });
	                    tempTpl += tpl(TPL.pageBtn, { className: 'pager-btn', text: totalPages });
	                }
	            }
	        } else {
	            var length = totalPages === 0 ? 1 : totalPages;
	            for (var _i3 = 1; _i3 <= length; _i3++) {
	                tempTpl += tpl(TPL.pageBtn, { className: _i3 === page ? 'pager-btn-current' : 'pager-btn', text: _i3 });
	            }
	        }
	        var onPageNumberClick = paging('pageNumber');
	        $ul.append(tempTpl).find('.pager-btn').each(function (index, item) {
	            var $item = $(item),
	                page = $(item).data('page');
	            $item.on('click.pager.pageNumber', function () {
	                onPageNumberClick([page]);
	            });
	        });
	    }
	
	    init();
	}
	var DATA_KEY = 'jq-pager';
	if (window.jQuery || window.Zepto) {
	    (function ($) {
	        'use strict';
	
	        $.fn.pager = function (params) {
	            var firstInstance = void 0;
	            this.each(function (i) {
	                var data = $(this).data(DATA_KEY);
	                if (!data) {
	                    data = new Pager(this, params);
	                    $(this).data(DATA_KEY, data);
	                }
	                if (!i) firstInstance = data;
	            });
	            return firstInstance;
	        };
	    })(window.jQuery || window.Zepto);
	}
	
	var tpl = exports.tpl = function () {
	    var cache = {};
	
	    function tmpl(str, data) {
	        // Figure out if we're getting a template, or if we need to
	        // load the template - and be sure to cache the result.
	        var fn = !/\W/.test(str) ? cache[str] = cache[str] || tmpl(document.getElementById(str).innerHTML) :
	
	        // Generate a reusable function that will serve as a template
	        // generator (and which will be cached).
	        new Function("obj", "var p=[],print=function(){p.push.apply(p,arguments);};" +
	
	        // Introduce the data as local variables using with(){}
	        "with(obj){p.push('" +
	
	        // Convert the template into pure JavaScript
	        str.replace(/[\r\t\n]/g, " ").split("<%").join("\t").replace(/((^|%>)[^\t]*)'/g, "$1\r").replace(/\t=(.*?)%>/g, "',$1,'").split("\t").join("');").split("%>").join("p.push('").split("\r").join("\\'") + "');}return p.join('');");
	
	        // Provide some basic currying to the user
	        return data ? fn(data) : fn;
	    }
	
	    return tmpl;
	}();

/***/ })

/******/ });


// WEBPACK FOOTER //
// institute.js